import { render } from "./HomepageSectionsView.vue?vue&type=template&id=65ac6a3c&scoped=true"
import script from "./HomepageSectionsView.vue?vue&type=script&lang=js"
export * from "./HomepageSectionsView.vue?vue&type=script&lang=js"

import "./HomepageSectionsView.vue?vue&type=style&index=0&id=65ac6a3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ac6a3c"]])

export default __exports__